<template>
    <div class="App" :style="{'backgroundImage': `url(${$imageSrcMap.home.menuBg})`}">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "App",
        props: {},
        data () {
            return {};
        },
        computed: {},
        created () {
            this.$Message.config({
                top: 50,
                duration: 5
            });
        },
        methods: {}
    };
</script>

<style lang="less" scoped>
    .App {
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-size: 100% 100%;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue